module.exports = __webpack_public_path__ + "img/heart_bj.c528e8ee.png";